/**
 * Alaska: Editor.js
 * Data: Count (used to build dynamic grid-cols-X)
 * @version 1.0
 */

document.addEventListener("alpine:init", () => {

    Alpine.data("Count", (target) => ({
        target,
        count: 0,

        init() {
            this.count = this.$el.querySelectorAll(`.${this.target}`).length;
        }

    }));
});